/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerCreditService = {

    async getSaleItemPrice(params) {
        var url = "api/SaleItemPrice?TransactionDate={TransactionDate}&SalesOrderTypeCode={SalesOrderTypeCode}&ItemType={ItemType}&BranchCode={BranchCode}&CustomerCode={CustomerCode}&ItemCode={ItemCode}&SalesUM={SalesUM}&SalesUMQty={SalesUMQty}&ExchangeRate={ExchangeRate}"
            .replace("{TransactionDate}", params.TransactionDate)
            .replace("{SalesOrderTypeCode}", params.SalesOrderTypeCode)
            .replace("{ItemType}", params.ItemType)
            .replace("{BranchCode}", params.BranchCode)
            .replace("{CustomerCode}", params.CustomerCode)
            .replace("{ItemCode}", params.ItemCode)
            .replace("{SalesUM}", params.SalesUM)
            .replace("{SalesUMQty}", params.SalesUMQty)
            .replace("{ExchangeRate}", params.ExchangeRate);
        return await ApiService.get(url);
    },
    async getActiveAccountingPeriodStartDate() {
        const requestScreenData = {
            url: "api/ActiveAccountingPeriod",
            top: "1",
            filter: `PeriodType eq 'AR'`,
            orderby: "StartDate",
        };

        return await ApiService.oDataGet(requestScreenData);
    },
    async getActiveAccountingPeriodEndDate() {
        const requestScreenData = {
            url: "api/ActiveAccountingPeriod",
            top: "1",
            filter: `PeriodType eq 'AR'`,
            orderby: "EndDate desc",
        };

        return await ApiService.oDataGet(requestScreenData);
    },
};

export { CustomerCreditService };
